var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleClosed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2662_2927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2662_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.438 13L14.396 8.062L13.333 7L9.438 10.875L7.667 9.125L6.604 10.188L9.438 13ZM10.5 18C9.40267 18 8.368 17.7917 7.396 17.375C6.424 16.9583 5.57333 16.3853 4.844 15.656C4.11467 14.9267 3.54167 14.076 3.125 13.104C2.70833 12.132 2.5 11.0973 2.5 10C2.5 8.88867 2.70833 7.85033 3.125 6.885C3.54167 5.92033 4.11467 5.07333 4.844 4.344C5.57333 3.61467 6.424 3.04167 7.396 2.625C8.368 2.20833 9.40267 2 10.5 2C11.6113 2 12.6497 2.20833 13.615 2.625C14.5797 3.04167 15.4267 3.61467 16.156 4.344C16.8853 5.07333 17.4583 5.92033 17.875 6.885C18.2917 7.85033 18.5 8.88867 18.5 10C18.5 11.0973 18.2917 12.132 17.875 13.104C17.4583 14.076 16.8853 14.9267 16.156 15.656C15.4267 16.3853 14.5797 16.9583 13.615 17.375C12.6497 17.7917 11.6113 18 10.5 18ZM10.5 16.5C12.3053 16.5 13.84 15.868 15.104 14.604C16.368 13.34 17 11.8053 17 10C17 8.19467 16.368 6.66 15.104 5.396C13.84 4.132 12.3053 3.5 10.5 3.5C8.69467 3.5 7.16 4.132 5.896 5.396C4.632 6.66 4 8.19467 4 10C4 11.8053 4.632 13.34 5.896 14.604C7.16 15.868 8.69467 16.5 10.5 16.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleClosed);
export default __webpack_public_path__ + "static/media/check_circle_closed.f958ca3ab0b8950c2a4fba162d97bf29.svg";
export { ForwardRef as ReactComponent };